import connectStats from 'instantsearch.js/cjs/connectors/stats/connectStats';
import type {
  StatsConnectorParams,
  StatsWidgetDescription,
} from 'instantsearch.js/cjs/connectors/stats/connectStats';
import { useConnector } from 'react-instantsearch-hooks-web';

export type UseStatsProps = StatsConnectorParams;

export default function useStats(props?: UseStatsProps) {
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats, props);
}
